import { render, staticRenderFns } from "./FormEmployeeFaixaContribuicao.vue?vue&type=template&id=9473716e"
import script from "./FormEmployeeFaixaContribuicao.vue?vue&type=script&lang=js"
export * from "./FormEmployeeFaixaContribuicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports